export const HOME_LOADER_ENABLED = true;
